// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_popup__2VDRY","outsideClickLayer":"popup_outsideClickLayer__3gDA4"};